import React, { useEffect, useState, useRef } from 'react'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact';
import { Tag } from 'primereact/tag';


import Card from '../../../../Base/Components/Card/Card'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid'
import { toastShow } from '../../../../Base/Services/ToastService';
import { downloadBase64Data } from '../../../../Base/Services/ArchivosService';


import { getControlMSDS, getFile, getListFile } from '../../../../API/Produccion/QuimicosColorantes/ControlQCRequests';
import { colorCotton, colorSintetico, color1, color2, color3, color4, color5 } from '../../../../Styles/Colors';



function ControlMSDSScreen() {

    const toast = useRef(null)

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filesList, setFilesList] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [loadingFile, setLoadingFile] = useState(false);
    const [Titulo, setTitulo] = useState('')

    const getInfo = async () => {
        setLoading(true);
        const t = await getControlMSDS()
        setProducts(t);
        setLoading(false);
    }


    const TipoTemplate = (rowData) => {
        switch (rowData.NombreTipo) {
            case 'Quimicos':
                return <Tag severity='danger' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorCotton }} />
                break;
            case 'Colorantes':
                return <Tag severity='info' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: '#ffc605' }} />
                break;

            default:
                return <div>{rowData.NombreTipo}</div>
                break;
        }
    }
    const CategoriaTemplate = (rowData) => {
        switch (rowData.Categoria) {
            case 'Acabado Algodón':
                return <Tag severity='danger' className='col-12' value={rowData.Categoria} style={{ backgroundColor: colorCotton }} />
                break;
            case 'Acabado Poliéster':
                return <Tag severity='info' className='col-12' value={rowData.Categoria} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Algodon Tintoreria':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: color1 }} />
                break;
            case 'Calderas':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: color2 }} />
                break;
            case 'Seguridad Industrial':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: color3 }} />
                break;
            case 'Sintetico Tintoreria':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: color4 }} />
                break;
            case 'Tratamiento de agua':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: color5 }} />
                break;

            default:
                return <div>{rowData.Categoria}</div>
                break;
        }
    }


    const obtenerArchivo = (e, area, tooltip) => {
        return <div className='col-12 d-flex align-items-center' style={{ textAlign: 'center' }}>
            <Button
                className='p-button-outlined p-button-text mx-3'
                icon='ri ri-folder-download-line'
                tooltip={tooltip}
                tooltipOptions={{ position: 'left' }}
                loading={loadingFile}
                // disabled={FileName === null}
                onClick={async() => { 
                    setLoadingFile(true);
                    setTitulo(tooltip);
                    const t = await getListFile(e?.IdProductoSuministro, area);
                    if(t.length > 0){
                        setFilesList(t);
                        setShowDialog(true)
                    }else{
                        toastShow(toast, 'warn', `El producto no tiene ${tooltip}.`)
                    }
                    setLoadingFile(false)
                 }}
                style={{ padding: '0' }}
            />
        </div>
    }

    const columns = [
        {
            header: 'Codigo',
            field: 'Codigo',
            className: 'small',
            frozen: true
        },
        {
            header: 'Producto',
            field: 'Producto',
            className: 'Xlarge',
            frozen: true,
            Sumary: 'count',
        },
        {
            header: 'Fecha',
            field: 'Fecha',
            Format: 'DateTime'
        },
        {
            header: 'Tipo producto',
            field: 'NombreTipo',
            className: 'small',
            Format: 'Template',
            body: TipoTemplate
        },
        {
            header: 'Categoria',
            field: 'Categoria',
            className: 'medium',
            Format: 'Template',
            body: CategoriaTemplate,
            filter: true
        },
        {
            header: 'TipoQC',
            field: 'TipoQC',
            className: 'small'
        },
        {
            header: 'MSDS',
            field: 'MSDS',
            Format: 'Checkbox',
            className: 'Xsmall'
        },
        {
            header: 'FechaHT',
            field: 'FechaHT',
            Format: 'Date'
        },
        {
            header: 'HojaTecnica',
            field: 'HojaTecnica',
            Format: 'Checkbox',
            className: 'Xsmall'
        },
        {
            header: 'FechaHT',
            field: 'FechaHT',
            Format: 'Date'
        },

        {
            header: 'ComponentesQQS',
            field: 'ComponentesQQS',
            className: 'XXXlarge'
        },
        {
            header: 'CAS',
            field: 'CAS',
            className: 'Xlarge'
        },
        {
            header: 'CI',
            field: 'CI',
        },
        {
            header: 'Peligrosidad',
            field: 'Peligrosidad',
            className: 'XXXlarge'
        },
        {
            header: 'Incompatibilidad',
            field: 'Incompatibilidad',
            className: 'XXXlarge'
        },
        {
            header: 'Fabricante',
            field: 'IdFabricante',
            className: 'XXXlarge'
        },
        // {
        //     header: 'Estado',
        //     field: 'Estado',
        //     Format: 'Template',
        //     className: 'Xsmall',
        //     body: stateTemplate
        // },
        {
            header: 'SMDS',
            field: 'SMDS',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Template',
            body: e => e.Codigo && obtenerArchivo(e, 5, 'SMDS')
        },
        {
            header: 'HT',
            field: 'HT',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Template',
            body: e => e.Codigo && obtenerArchivo(e, 6, 'Hoja Técnica')
        },


    ]

    const table = {
        Columns: columns,
        Data: products,
        loading: loading
    }


    const DescriptionTemplate = (rowData) => {
       switch (rowData.Area) {
        case 5:
            return <span>MSDS</span>
            break;
        case 6:
            return <span>Hoja Técnica</span>
            break;
       
        default:
            return <pan> </pan>
            break;
       }
    }

    const DescargarTemplate = (e) => {
       return <div className='col-12 d-flex align-items-center' style={{ textAlign: 'center' }}>
       <Button
           className='p-button-outlined p-button-text mx-3'
           icon='pi pi-download'
           tooltip={'Descargar'}
           tooltipOptions={{ position: 'left' }}
           // disabled={FileName === null}
           loading={loadingFile}
           onClick={async() => { 
            setLoadingFile(true);
            const File = await getFile(e.IdFile);
            if(File.length > 0){
                downloadBase64Data({ Data: File[0]?.Data, Tipo: File[0]?.Tipo });
            }else{
                toast(toast, 'warn', 'Archivo no encontrado.')
            }
            setLoadingFile(false);
            }}
           style={{ padding: '0' }}
       />
       </div>
    }

    const tableFiles = {
        Columns: [
            {
                header: 'Nombre',
                field: 'Nombre',
                className: 'XXlarge'
            },
            {
                header: 'Descripción',
                field: 'Nombre',
                Format: 'Template',
                body: DescriptionTemplate
            },
            {
                header: 'Descargar',
                field: '',
                className: 'Xsmall',
                Format: 'Template',
                body: DescargarTemplate
            },
            
        ],
        Data: filesList
    }

    const onHide = () => {
        setShowDialog(false);
        setFilesList([]);
        setTitulo('')
    }


    useEffect(() => {
        window.document.title = 'PPF • Control MSDS y HT';
        getInfo()
    }, [])


    return (
        <div>
            <Toast ref={toast} />
            <Card
                titulo={<div><h3>Control MSDS y HT</h3></div>}
                contenido={<div style={{ height: '90vh' }} className='py-3'>
                    <AgGrid table={table} />
                </div>}
            />

            <Dialog visible={showDialog} onHide={onHide} header={<h3>{Titulo}</h3>}>
                <div style={{ height: '50vh', width: '40vw' }}>
                    <AgGrid table={tableFiles} />
                </div>
            </Dialog>
        </div>
    )
}

export default ControlMSDSScreen